import { EntityPro2doc } from "../../entity/EntityPro2doc";

export class DtoPro2docsPutRes extends EntityPro2doc {}
